export enum LastModifiedDateTypeEnum {
    LAST_7_DAYS = 'LAST_7_DAYS',
    LAST_14_DAYS = 'LAST_14_DAYS',
    LAST_21_DAYS = 'LAST_21_DAYS',
    LAST_30_DAYS = 'LAST_30_DAYS',
    CUSTOM = 'CUSTOM'
}
